export default function SessionRecovery({ onSignIn }) {
  return <section className="auth-layout">
    <div className="auth-panel" style={{ gridColumn: '1 / -1' }}>
    <main className="auth-card" id="main-content">
      <h1 className="auth-title">No pudimos recuperar tu sesión</h1>
      <p className="auth-subtitle" role="alert">No se pudo validar tu sesión en este momento. Inténtalo de nuevo cuando el servicio esté disponible.</p>
      <button className="btn btn-primary auth-submit" type="button" onClick={() => window.location.reload()}>Reintentar</button>
      <button className="btn btn-secondary" type="button" onClick={onSignIn}>Iniciar sesión</button>
    </main>
    </div>
  </section>;
}
